import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { LoginProvider } from "./APIContext/LoginContext";
import { PrimeReactProvider } from "primereact/api";
import { HelmetProvider } from "react-helmet-async";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const primeReactConfig = {
  ripple: true,
  zIndex: {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <PrimeReactProvider value={primeReactConfig}>
        <LoginProvider>
          <App />
        </LoginProvider>
      </PrimeReactProvider>
    </BrowserRouter>
  </HelmetProvider>,
);

reportWebVitals();
